// src/components/Footer/Footer.js
import React from 'react';

const Footer = () => {
    return (
        <footer style={{
            backgroundColor: '#333',
            color: '#fff',
            textAlign: 'center',
            padding: '20px 0',
            
            bottom: 0,
            width: '100%',
        }}>
            <p>&copy; Amazon shopping</p>
        </footer>
    );
};

export default Footer;
